export enum Mode {
  DEV = "development",
  PROD = "production",
}

interface WithEnvMode {
  readonly env: {
    readonly MODE: Mode;
  };
}

export const mode = (import.meta as unknown as WithEnvMode).env.MODE;

declare const __API_PATH__: string;
export const API_PATH = __API_PATH__;

declare const __API_HOST__: string;
export const API_HOST = __API_HOST__;

declare const __API_PREFIX_PATH__: string;
export const API_PREFIX_PATH = __API_PREFIX_PATH__;

// super_admin verwaltet TireVault nicht mehr selbst (siehe Memory
// project_superadmin_portal_migration) — wird bei jedem Zugriff hierhin umgeleitet.
export const PORTAL_ADMIN_URL = "https://werkstatt-connect.de/admin";
